import { BaseMark } from '../BaseMark.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'klasmaAbove';
const args = {};

export class KlasmaAbove extends BaseMark {
  constructor() {
    super(glyphname, args);
  }
}
